"use client";

import type { VariantProps } from "class-variance-authority";
import { type CSSProperties, type PropsWithChildren, type Ref, useMemo } from "react";

import cn from "../../utils/cn.util";
import { CardContext } from "./context";
import { rootStyles } from "./styles";

export type CardRootProps = PropsWithChildren<{
  id?: string;
  className?: string;
  ref?: Ref<HTMLDivElement>;
  style?: CSSProperties;
}> &
  VariantProps<typeof rootStyles>;

export const Root = ({ id, ref, children, className, variant = "primary", style }: CardRootProps) => {
  const contextValue = useMemo(() => {
    return {
      variant,
    };
  }, [variant]);

  return (
    <CardContext value={contextValue}>
      <div id={id} ref={ref} className={cn(rootStyles({ variant }), className)} style={style}>
        {children}
      </div>
    </CardContext>
  );
};

Root.displayName = "CardRoot";
